export default __webpack_public_path__ + "0cbf778f512901aba7608853358d8880.svg";